import { decodeItems } from "../data";
import SectionHead from "./SectionHead";

export default function Meaning() {
  return (
    <section id="meaning" className="bg-background-50 py-14 md:py-20">
      <div className="wrap grid items-start gap-10 lg:grid-cols-[0.9fr_1.1fr]">
        <SectionHead
          no="01"
          title="吃瓜91 什么意思？"
          desc="一句话版本先给到你：它不是一个有唯一标准答案的词，而是一个把「吃瓜」这个围观动作和数字 91 叠在一起的网络表达。懂了这个结构，基本就懂了它。"
        />

        <div className="rounded-lg border border-accent-200 bg-accent-50 p-6 md:p-8">
          <div className="mb-3 inline-flex items-center gap-2 text-xs font-semibold text-accent-700">
            <i className="ri-lightbulb-flash-line h-4 w-4 flex items-center justify-center" />
            速读结论
          </div>
          <p className="eyebrow text-xl font-semibold leading-relaxed text-foreground-900 md:text-2xl">
            「吃瓜」= 围观八卦、坐等更新；
            <br />
            「91」≈ 谐音“就要 / 就一”。
          </p>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700">
            合起来的画面感是——<strong className="font-semibold text-primary-700">“有人喊你前排就位，一起等瓜”</strong>。
            它更像一个接头暗号，发出来是拉你进入同一场热闹，而不是真的要你解题。
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            <div className="flex items-center gap-2 rounded-md bg-background-50 px-3 py-2 text-xs text-foreground-600">
              <i className="ri-chat-smile-3-line h-4 w-4 flex items-center justify-center text-primary-500" />
              偏口语、轻松场合
            </div>
            <div className="flex items-center gap-2 rounded-md bg-background-50 px-3 py-2 text-xs text-foreground-600">
              <i className="ri-group-line h-4 w-4 flex items-center justify-center text-accent-600" />
              评论区 / 弹幕 / 群聊高频
            </div>
            <div className="flex items-center gap-2 rounded-md bg-background-50 px-3 py-2 text-xs text-foreground-600">
              <i className="ri-megaphone-line h-4 w-4 flex items-center justify-center text-secondary-600" />
              发出来≈邀你进场
            </div>
          </div>
        </div>
      </div>

      {/* 逐字拆解 */}
      <div className="wrap mt-12 grid gap-4 md:grid-cols-3">
        {decodeItems.map((it) => (
          <article key={it.title} className="rounded-lg border border-background-200 bg-background-100 p-5">
            <span className="inline-block rounded-md bg-primary-100 px-2 py-0.5 text-xs font-semibold text-primary-700">
              {it.badge}
            </span>
            <h3 className="eyebrow mt-3 text-base font-bold text-foreground-950">{it.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{it.summary}</p>
          </article>
        ))}
      </div>
    </section>
  );
}